<template>
  <div>
    <ibox>
      <template slot="title">会員一覧</template>
      <template slot="tools">
        <!--<button class="btn btn-info btn-outline btn-xs btn-bitbucket" v-on:click="memberDownload">-->
        <!--<i class="fa fa-download"></i> Download-->
        <!--</button>-->
        <router-link to="/member/create">
          <button class="btn btn-info btn-outline btn-xs btn-bitbucket">
            会員登録
          </button>
        </router-link>
      </template>
      <template slot="body">
        <div class="row">
          <div class="col-lg-12">
            <MemberSearch
                @clickSearch="clickSearch"></MemberSearch>
            <div class="form-group">
              <div class=" col-sm-12">
                <table class="table table-hover">
                  <thead>
                  <tr>
                    <th>登録日</th>
                    <th>会員ID</th>
                    <th>メールアドレス</th>
                    <th>メルマガ</th>
                    <th>氏名</th>
                    <th></th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>

                  <template v-for="(member,index) in members">
                    <member-list-row :member="member" @clickSearch="clickSearch"
                                     @showModal="showModal"></member-list-row>
                  </template>
                  </tbody>
                </table>
                <pager @click="clickPager" v-bind:pager="pager"></pager>
              </div>
            </div>
            <line-dashed/>
          </div>
        </div>
      </template>
    </ibox>
    <!--<modal v-if="isModal" @close="showModal=false">-->
    <!--<template v-if="delete_member.member_id" slot="header">会員削除</template>-->
    <!--<template slot="body">-->
    <!--【{{delete_member.name}}】様の個人情報を完全に隠します。<br/>-->
    <!--このデータに紐づく全ての個人情報について、今後全く参照することができなくなります。-->
    <!--</template>-->
    <!--<template slot="footer">-->
    <!--<button class="btn " v-on:click="isModal=false">キャンセル</button>-->
    <!--<button class="btn btn-primary" v-on:click="deleteMember">会員を削除</button>-->
    <!--</template>-->
    <!--</modal>-->
  </div>
</template>

<script>
import Api from '../../service/Api.vue'
import MemberSearch from '../../components/member/Search.vue'
import Csv from '../../service/Csv.vue'

export default {
  data () {
    return {
      params: {},
      members: [],
      pager: false,
      isModal: false,
      delete_member: []
    }
  },
  methods: {
    clickSearch: function (data) {
      this.params.page = 1
      this.params = data
      this.memberSearch(data)
    },
    clickPager: function (page) {
      this.params.page = page
      this.memberSearch(this.params)
    },
    memberSearch: function (data) {
      this.params = data
      data.order = 'member_id'
      data.sort = 'DESC'
      Api.member.search(data).then(this.searchSuccess)
    },
    memberDownload: function () {
      Api.member.csv(this.params).then(function (response) {
        Csv.download('UNIQUERY_会員一覧.csv', response.data)
      })
    },
    searchSuccess: function (response) {
      this.members = response.data.members
      this.pager = response.data.pager
      this.$nextTick(function () {
      })
    },
    showModal: function (data) {
      this.isModal = true
      this.delete_member = data
    },
    deleteMember: function () {
      Api.member.removeForce(this.delete_member.member_id)
        .then(this.successDelete)
        .catch(this.failureDelete)
    },
    successDelete (response) {
      this.isModal = false
      this.delete_member = []
      this.clickSearch(this.params)
    },
    failureDelete (errors) {
      this.delete_member = []
      this.isModal = false
    }
  },
  components: {
    MemberSearch
  }
}
</script>



// WEBPACK FOOTER //
// List.vue?69883757